var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-spinner"},[_c('a-icon',{attrs:{"icon":"Spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }